import { render, staticRenderFns } from "./HomeEventsSkeleton.vue?vue&type=template&id=62f9461f&"
import script from "./HomeEventsSkeleton.vue?vue&type=script&lang=js&"
export * from "./HomeEventsSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./HomeEventsSkeleton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
